<template>
  <div class="home">
    <section class="content">
      <header class="header">
        <div class="header-content content-width">
          <img :src="solarImg" alt="" />

          <div class="aside">
            <p class="title text-center color-orange-red">{{ header.title }}</p>
            <p class="sub-title color-orange-red">
              {{ header.subTitle }}
            </p>
          </div>
        </div>
      </header>

      <div class="body">
        <div class="body-content content-width">
          <el-divider class="divider">
            <span class="title color-black">应用展示</span>
          </el-divider>
        </div>
        <div class="products">
          <div class="products-box content-width flex-box flex-between">
            <el-row style="width: 100%; padding: 12px 0">
              <el-col :span="6" :offset="6">
                <div
                  class="text-center products-box_item animate__animated animate__bounceInDown"
                >
                  <p class="title">玄综八字</p>
                  <div class="bazi"></div>
                </div>
              </el-col>
              <el-col :span="6" :offset="3">
                <div
                  class="text-center products-box_item animate__animated animate__bounceInDown"
                >
                  <p class="title">寻卜</p>
                  <div class="xunbu"></div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="body-content content-width">
          <el-divider class="divider">
            <span class="title color-black">小程序展示</span>
          </el-divider>
        </div>
        <div class="products">
          <div class="products-box content-width flex-box flex-between">
            <el-row style="width: 100%; padding: 12px 0">
              <el-col :span="6" :offset="6">
                <div
                  class="text-center products-box_item animate__animated animate__bounceInDown"
                >
                  <p class="title">玄综万年历</p>
                  <div class="wannianli"></div>
                </div>
              </el-col>
              <el-col :span="6" :offset="3">
                <div
                  class="text-center products-box_item animate__animated animate__bounceInDown"
                >
                  <p class="title">玄综罗盘</p>
                  <div class="luopan"></div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>

        <div class="body-content content-width">
          <el-divider class="divider">
            <span class="title color-black">证书墙</span>
          </el-divider>
        </div>
        <div class="team">
          <div class="team-box content-width flex-box flex-between">
            <team />
          </div>
        </div>
      </div>
    </section>

    <footer class="footer flex-box flex-column color-base">
      <div class="copyright flex-box">
        南京玄综文化有限公司 All Rights Reserved
      </div>
      <div class="beian flex-box">
        <img style="width: 14px; margin: 0 6px" :src="policeImg" />
        <a
          href="https://beian.mps.gov.cn/#/query/webSearch?code=32010602011337"
          target="_blank"
          class="color-base"
          >{{ config.gongan }}</a
        >
        &nbsp;&nbsp; | &nbsp;&nbsp;
        <a
          href="https://beian.miit.gov.cn/"
          target="_blank"
          class="color-base"
          >{{ config.beian }}</a
        >
      </div>
    </footer>
  </div>
</template>

<script>
import Team from "./team";

export default {
  name: "HomeView",
  components: { Team },
  data() {
    return {
      config: {
        gongan: "苏公网安备32010602011337",
        beian: "苏ICP备2023046287号-1",
      },
      solarImg: require("@/assets/images/solar.png"),
      policeImg: require("@/assets/images/police.png"),
      header: {
        title: "探索自然真理",
        subTitle:
          "自然是宇宙的法则，命理是人生的指南。顺应自然，才能与万物和谐共生；遵循命理，方能在人生道路上行稳致远。",
      },
    };
  },
};
</script>

<style lang="less" scoped>
.home {
  .content {
    .content-width {
      width: 1140px;
      margin: 0 auto;
    }

    .header {
      background: linear-gradient(
        90deg,
        rgba(209, 188, 220, 0.2),
        rgba(252, 240, 206, 0.3)
      );

      .header-content {
        position: relative;

        .aside {
          position: absolute;
          left: 30px;
          top: 30%;
          transform: translateY(-50%);
          background: rgba(255, 255, 255, 0.4);
          padding: 0 30px;
          border-radius: 12px;
          width: 20%;
          box-shadow: 2px 3px 5px rgba(0, 0, 0, 0.2);
          backdrop-filter: blur(3px);

          p {
            user-select: none;
            pointer-events: none;

            &.title {
              font-size: 24px;
              text-shadow: 0 0 2px rgba(255, 87, 34, 0.2);
            }

            &.sub-title {
              font-size: 18px;
              opacity: 0.82;
            }
          }
        }
      }
    }

    .body {
      .divider {
        margin: 40px auto;
        width: 38.2%;

        .title {
          user-select: none;
        }
      }

      .products {
        background: #fffdfa;
        padding: 15px 0;
        position: relative;

        &-box {
          &_item {
            width: 100%;
            color: #000;
            // border: 1px solid #efefef;
            background: transparent;

            .bazi,
            .xunbu,
            .luopan,
            .wannianli {
              height: 338px;
              position: relative;

              &::before {
                content: "";
                position: absolute;
                width: 100%;
                height: 100%;
                left: 0;
                top: 10px;
                background-image: url(../../assets/images/bazi/271702391159_.pic.jpg);
                background-position: 30%;
                background-repeat: no-repeat;
                background-size: auto calc(100% - 30px);
              }

              &::after {
                content: "";
                position: absolute;
                width: 100%;
                height: 100%;
                left: 0;
                top: 0px;
                opacity: 0.92;
                background-image: url(../../assets/images/bazi/281702392034_.pic.jpg);
                background-repeat: no-repeat;
                background-size: auto calc(100% - 10px);
                background-position: 58%;
              }
            }

            .xunbu {
              &::before {
                background-image: url(../../assets/images/xunbu/WechatIMG35.jpg);
              }

              &::after {
                background-image: url(../../assets/images/xunbu/WechatIMG36.jpg);
              }
            }

            .wannianli {
              &::before {
                background-image: url(../../assets/images/wannianli/WechatIMG173.jpg);
              }

              &::after {
                background-image: url(../../assets/images/wannianli/WechatIMG174.jpg);
              }
            }

            .luopan {
              &::before {
                background-image: url(../../assets/images/luopan/WechatIMG175.jpg);
              }

              &::after {
                background-image: url(../../assets/images/luopan/WechatIMG177.jpg);
              }
            }

            p {
              &.title {
                font-size: 16px;
                margin: 0 auto;
                line-height: 48px;
                font-weight: bold;
                letter-spacing: 2px;
              }

              &.sub-title {
                font-size: 14px;
                opacity: 0.82;
                height: 144px;
                margin: 0 auto;
              }
            }
          }
        }
      }
    }
  }

  .footer {
    padding: 25px 35px;
    background: #f7f7f8;

    .beian {
      a {
        text-decoration: none;
      }
    }
  }
}
</style>
